import { FC } from 'react'
import { Box, H1 } from '@branch-messenger/willow-ui'
import { isInIframe } from '@lib/originHelpers'

import { FlowCardHeadingProps } from './types'

const inIframe = isInIframe()
export const FlowCardHeader: FC<FlowCardHeadingProps> = ({
  ref,
  subtitle,
  children,
  icon,
}) => {
  return (
    <Box $display="flex" $direction="column" $align="stretch" $gap={4}>
      {icon && (
        <Box $display="flex" $justify="center">
          {icon}
        </Box>
      )}
      {/* In iframe, there may be other headers on the page, so we'll use a p if in an iframe so we don't conflict */}
      <H1 as={inIframe ? 'p' : undefined} ref={ref}>
        {children}
      </H1>
      {subtitle}
    </Box>
  )
}
